import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import weekday from 'dayjs/plugin/weekday';
import { isMobile } from 'react-device-detect';
import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import { pickupShiftService } from '../../../../../services/scheduling';
import { isResponseOk } from '../../../../../utility/isResponseOk';
import './styles.scss';
import cx from 'classnames';
import { toast } from 'react-toastify';
import { convertTimeRangeTo12Hour } from '../../../../../utility';
import { useAuth } from '../../../../../container/authContext';
import { getRoleLabelsService } from '../../../../../services/company';

dayjs.extend(advancedFormat);
dayjs.extend(weekday);

const ConfirmPickupShiftModal = ({ closeModal, data, setPickupShiftData }) => {
  const { user } = useAuth();
  const [roleLabels, setRoleLabels] = useState({});

  useEffect(() => {
    getRoleLabelsService(user?.company?.id).then((res) => {
      setRoleLabels(res.data);
    });
  }, [user?.company?.id]);

  const handleClose = () => {
    closeModal();
  };

  const handleConfirm = async () => {
    try {
      const payload = {
        half_type: data.half,
      };

      const response = await pickupShiftService(data.cell.id, payload);
      if (isResponseOk(response)) {
        setPickupShiftData((state) => [...state.map((item) => (item.id === data.cell.id ? response.data : item))]);
        toast.success('The request to pickup shift was successfully sent', { hideProgressBar: false });
      }
      closeModal();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Modal
      className={cx('modal-alert confirm-pickup-modal', { isMobile })}
      isOpen
      onRequestClose={handleClose}
      contentLabel="Delete note modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="38" height="38" rx="19" fill="#F4EBFF" />
          <rect x="5" y="5" width="38" height="38" rx="19" stroke="#F9F5FF" strokeWidth="10" />
          <path
            d="M26.6667 17.3359V20.0026M21.3333 17.3359V20.0026M18 22.6693H30M19.3333 18.6693H28.6667C29.403 18.6693 30 19.2662 30 20.0026V29.3359C30 30.0723 29.403 30.6693 28.6667 30.6693H19.3333C18.597 30.6693 18 30.0723 18 29.3359V20.0026C18 19.2662 18.597 18.6693 19.3333 18.6693Z"
            stroke="#7F56D9"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Pickup {data.cell.role === 'nurse' ? roleLabels?.nurse_role_label : roleLabels?.cna_role_label} shift</h3>
        <p className="shift-info-subtitle">
          {dayjs(data.cell.date).format('MM/DD dddd')}, shift {convertTimeRangeTo12Hour(data.cell.shift_name)}
        </p>
        <p className="confirm-subtitle">Are you sure you want to pick up this shift?</p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          Pickup shift
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmPickupShiftModal;
